import styled, { css } from "styled-components";

import { mobile } from "@sellernote/ui/src/styles/functions";

import { COLOR, TEXT_COLOR } from "../../styles/colors";
import { setFontStyle } from "../../styles/typography";

const container = styled.div<{ width?: string }>`
  width: ${({ width }) => width || "100%"};
  text-align: left;
`;

const item = styled.div<{ opens: boolean; usesDivider?: boolean }>`
  padding: 0 12px;

  color: ${({ opens }) => (opens ? TEXT_COLOR.black_1 : TEXT_COLOR.black_3)};

  ${({ usesDivider }) => {
    if (usesDivider) {
      return css`
        border-bottom: 1px solid ${COLOR.grayScale_200};
      `;
    } else {
      return css`
        &:not(:first-child) {
          margin: 8px 0;

          ${mobile(css`
            margin: 4px 0;
          `)}
        }
      `;
    }
  }}

  ${mobile(css`
    padding: 0 8px;
  `)}


  > .title {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    padding: 18px 0;
    ${setFontStyle("SubHead1")};

    ${mobile(css`
      padding: 16px 0;
      ${setFontStyle("SubHead2")};
    `)}

    > .icon {
      margin-right: 8px;
      flex-shrink: 0;
    }
  }

  > .desc {
    margin-top: 5px;
    margin-bottom: 8px;
    ${setFontStyle("Body2")};

    ${mobile(css`
      ${setFontStyle("Body3")};
    `)}
  }
`;

export default {
  container,
  item,
};
